
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ventures/[slug]",
      function () {
        return require("private-next-pages/ventures/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ventures/[slug]"])
      });
    }
  